import { useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n0, n2 } from "../../lib/format";
import { LineChart } from "../../lib/charts";
import { addDays, iso } from "../../lib/dates";
import { Notice, Stat } from "../../lib/ui";

/* Sales of one product over a period – port of saleIndividual.php (API: /api/sales/product) */

export default function ProductSales() {
  const api = useApi();
  const [products, setProducts] = useState([]);
  const [term, setTerm] = useState("");
  const [f, setF] = useState({ product_id: "", start_date: iso(addDays(new Date(), -30)), end_date: iso(new Date()) });
  const [d, setD] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { api.get("/api/products/options").then(setProducts).catch((e) => setError(e.message)); }, [api]);
  const matches = products.filter((p) => !term || p.name.toLowerCase().includes(term.toLowerCase())).slice(0, 200);
  const run = (e) => { e.preventDefault(); setD(null); api.get("/api/sales/product", f).then(setD).catch((er) => setError(er.message)); };

  return (
    <main className="pg">
      <PageHeader slug="saleIndividual" />
      <Notice notice={error && { tone: "err", text: error }} />
      <section className="panel" style={{ marginBottom: "1.25rem" }}>
        <form className="toolbar" style={{ borderBottom: 0 }} onSubmit={run}>
          <div className="field grow"><label htmlFor="ps-q">Find product</label><input id="ps-q" value={term} onChange={(e) => setTerm(e.target.value)} placeholder="Type to narrow the list" /></div>
          <div className="field grow"><label htmlFor="ps-p">Product</label>
            <select id="ps-p" required value={f.product_id} onChange={(e) => setF({ ...f, product_id: e.target.value })}>
              <option value="">Choose a product</option>{matches.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}</select></div>
          <div className="field"><label htmlFor="ps-s">From</label><input id="ps-s" type="date" required value={f.start_date} onChange={(e) => setF({ ...f, start_date: e.target.value })} /></div>
          <div className="field"><label htmlFor="ps-e">To</label><input id="ps-e" type="date" required value={f.end_date} onChange={(e) => setF({ ...f, end_date: e.target.value })} /></div>
          <button type="submit" className="btn primary">Show sales</button>
        </form>
      </section>
      {d && (d.rows.length === 0 ? <div className="panel empty"><i className="fas fa-inbox" />No sales of this product in that period.</div> : (
        <>
          <h2 style={{ fontSize: "1.1rem", margin: "0 0 .8rem" }}>{d.product_name}</h2>
          <div className="ui-stats">
            <Stat icon="fa-cubes" tone="muted" label="Units sold" value={n0(d.total_qty)} />
            <Stat icon="fa-coins" tone="up" label="Sales" value={n0(d.total_sales)} unit="TZS" />
            <Stat icon="fa-sack-dollar" label={`Profit · margin ${d.margin_pct.toFixed(1)}%`} value={n0(d.total_profit)} unit="TZS" />
            <Stat icon="fa-tag" tone="warn" label="Average price" value={n2(d.avg_price)} unit="TZS" />
          </div>
          <section className="panel card-pad" style={{ marginBottom: "1.25rem" }}><h3>By day</h3>
            <LineChart labels={d.by_date.map((x) => x.date)} series={[{ name: "Sales", values: d.by_date.map((x) => x.sales) }, { name: "Profit", values: d.by_date.map((x) => x.profit) }]} /></section>
          <section className="panel"><div className="tbl-wrap"><table className="tbl">
            <thead><tr><th>Date</th><th className="num">Qty</th><th className="num">Price</th><th className="num">Total</th><th className="num">Profit</th></tr></thead>
            <tbody>{d.rows.map((r, i) => <tr key={i}><td>{r.sale_date}</td><td className="num mono">{n0(r.quantity_sold)}</td><td className="num mono">{n2(r.sale_price)}</td>
              <td className="num mono">{n2(r.total_amount)}</td><td className="num mono">{n2(r.profit)}</td></tr>)}</tbody>
          </table></div></section>
        </>
      ))}
    </main>
  );
}
